import { useEffect, useState } from 'react'

let isDialogOpenState = false
let listeners = []

const setVerifyPaymentDialogState = (state) => {
    isDialogOpenState = state
    listeners.forEach(listener => listener(isDialogOpenState))
}

const subscribe = (listener) => {
    listeners.push(listener)
    return () => {
        listeners = listeners.filter(l => l !== listener)
    }
}


export const useVerifyPayment = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(isDialogOpenState)

    useEffect(() => {
        const unsubscribe = subscribe(setIsDialogOpen)
        return () => unsubscribe()
    }, []);

    return isDialogOpen
}

export const toggleVerifyPayment = (state) => setVerifyPaymentDialogState(state)